import { URL_GENRES } from '../helpers/endpoint';
import { baseBackend } from './base/baseUrl';

export const getGenres = async () => {
  return await baseBackend.get(URL_GENRES, {
    headers: { "Content-Type": "application/json" },
    //withCredentials: true,
  });
};